import anyLeague from "../../classificators/league/anyLeague.js";
import generalScopeContext from "../../classificators/resultsSlice/generalScopeContext.js";
import resultsSliceForPlayer from "../../classificators/resultsSlice/resultsSliceForPlayer.js";
import satisfiesAll from "../../classificators/satisfiesAll.js";
import sessionClassifierBuilder from "../../classificators/session/sessionClassifierBuilder.js";
import gameOnly from "../../classificators/sessionType/gameOnly.js";
import RankingStat from "../../entities/RankingStat.js";
import GeneralRankingStats from "../../enums/GeneralRankingStats.js";
import NumberFormatter from "../../formatters/NumberFormatter.js";
import RankingStatCaseVerifier from "../../validators/RankingStatCaseVerifier.js";
import RankingStatCalculatorBase from "./RankingStatCalculatorBase.js";

class GamesPlayedCalculator extends RankingStatCalculatorBase {
    constructor(rankingStatCaseVerifier, numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }

        super(
            [ GeneralRankingStats.GamesPlayed ],
            rankingStatCaseVerifier || new RankingStatCaseVerifier(
                anyLeague,
                sessionClassifierBuilder(gameOnly),
                satisfiesAll(generalScopeContext, resultsSliceForPlayer)
            )
        );

        this.numberFormatter = numberFormatter || new NumberFormatter(0);
    }

    /**
     * Calculates given statistical parameter
     * @param {object} parameter - a parameter to calculate, object from Enum PitchingRankingStats, BattingRankingStats or GeneralRankingStats
     * @param {ResultsSlice} slice - result slice with scope
     * @param {object} session - session object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/session-v2.json
     * @param {object} league - league object, @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/entity/league.json
     * @returns {RankingStat|null} RankingStat instance or null when calculation wasn't possible
     */
    calculateStat(parameter, slice, session, league) {
        return RankingStat.fromParameter(
            this.supportedParams[0],
            this.numberFormatter.format(1),
            1
        );
    }

    filterResults(results, session, league) {
        return this.contextualFilter.filter(results, session, league);
    }
}

export default GamesPlayedCalculator;